import { render, staticRenderFns } from "./LmProcessLink.vue?vue&type=template&id=398375bf&scoped=true&"
import script from "./LmProcessLink.vue?vue&type=script&lang=js&"
export * from "./LmProcessLink.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessLink.vue?vue&type=style&index=0&id=398375bf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398375bf",
  null
  
)

export default component.exports